<vl-form-grid mod-stacked>
	<vl-column v-if="error">
		<vl-alert icon="alert-circle" title="Onbekende fout" mod-error>
				<p>Er heeft zich een onbekende fout voorgedaan. Gelieve later opnieuw te proberen.</p>
		</vl-alert>
	</vl-column>
	<vl-column v-if="showConfirmCheckbox">
		<vl-checkbox v-model="confirmCheckboxValue" ref="confirmCheckbox">
            Ik bevestig dat ik gearchiveerde gegevens niet zal gebruiken voor het uitvoeren van grondwerken.
        </vl-checkbox>
	</vl-column>
	<vl-column>
        <vl-link :href="fileUrl" ref="downloadButton" mod-button :mod-disabled="isDownloadButtonDisabled">{{ downloadButtonText }}</vl-link>
	</vl-column>
</vl-form-grid>
